import { useEffect, useState } from "react";

const QUERY = "(max-width: 767px)";

/**
 * True below the 768px breakpoint. Panels use it to switch from floating cards
 * / a right drawer to bottom sheets (brief §13).
 */
export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(() => window.matchMedia(QUERY).matches);

  useEffect(() => {
    const mql = window.matchMedia(QUERY);
    const onChange = () => setIsMobile(mql.matches);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return isMobile;
}
